import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { map } from 'rxjs';
import { AuthService } from '../../../auth/auth.service';

@Component({
    selector: 'dashboard-header',
    templateUrl: './dashboard-header.component.html',
    styleUrls: ['./dashboard-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DashboardHeaderComponent {
  private readonly authService = inject(AuthService);

  public readonly userName$ = this.authService.user$.pipe(
    map((user) => user?.name ?? null),
  );
}
